import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import styles from './SurveyCard.module.scss';
import { generatePath, useHistory } from 'react-router-dom';
import { parseDate } from '../../../helpers/date';
import { routes } from '../../../assets/routes';
import { useTranslation } from '../../../i18n/LanguageProvider';

const SurveyCard = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Card
      {...props}
      extraClass={styles.surveyCard}
      onClick={() => {
        history.push({
          pathname: generatePath(routes.SURVEY, { id: props.data.id }),
          state: { uneditable: props.uneditable }
        });
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <div className={styles.info}>
            <div className={styles.pics}>
              <div>{props.data.title}</div>
            </div>
            <p>{props.data.description}</p>
          </div>
          <div className={styles.feedback}>
            <div className={styles.time}>
              <div>{t('survey.deadline')}</div>
              <span>{parseDate(props.data.end_at)}</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

SurveyCard.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    responded: PropTypes.bool,
    all_employee: PropTypes.bool,
    description: PropTypes.string,
    end_at: PropTypes.string,
    id: PropTypes.number,
    recipients: PropTypes.array,
    organization_id: PropTypes.number,
    is_active: PropTypes.bool,
    last_response_submitted: PropTypes.number
  }),
  uneditable: Boolean
};

export default SurveyCard;
